/* ============================================
   STILENZA — Lightweight Animations
   CSS Transitions + IntersectionObserver
   Zero dependencies, zero forced reflow
   ============================================ */

(function() {
  'use strict';

  const _observers = [];

  // Defer all animation setup to avoid blocking first paint
  const init = function() {
    // Respect reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.stilenza-reveal, .stilenza-stagger > *, .stilenza-mask-reveal').forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }

    // Mark body so CSS knows animations are ready
    document.documentElement.classList.add('stil-anim-ready');

    // --- IntersectionObserver for scroll reveals ---
    const revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
    _observers.push(revealObserver);

    // Fade-up reveals
    document.querySelectorAll('.stilenza-reveal').forEach(function(el) {
      revealObserver.observe(el);
    });

    // Staggered grid reveals — set delay per child
    document.querySelectorAll('.stilenza-stagger').forEach(function(group) {
      Array.from(group.children).forEach(function(child, i) {
        child.style.transitionDelay = (i * 0.15) + 's';
      });
      revealObserver.observe(group);
    });

    // Mask reveals (clip-path wipe from bottom)
    document.querySelectorAll('.stilenza-mask-reveal').forEach(function(el) {
      revealObserver.observe(el);
    });

    // --- Parallax (desktop only, passive scroll, no layout reads in scroll handler) ---
    // Read viewport width once, outside scroll handler
    const isDesktop = document.documentElement.clientWidth >= 750;
    if (isDesktop) {
      const parallaxEls = document.querySelectorAll('.stilenza-parallax');
      if (parallaxEls.length) {
        let ticking = false;
        window.addEventListener('scroll', function() {
          if (!ticking) {
            requestAnimationFrame(function() {
              const y = window.scrollY;
              parallaxEls.forEach(function(el) {
                const speed = parseFloat(el.dataset.speed) || 0.3;
                el.style.transform = 'translate3d(0,' + (-y * speed * 0.05) + 'px,0)';
              });
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });
      }
    }

    // --- Marquee / Ticker (pure CSS animation) ---
    document.querySelectorAll('.stilenza-marquee__track').forEach(function(track) {
      if (track.children.length === 0) return;
      // Clone nodes instead of reading+writing innerHTML (avoids reflow)
      const clone = track.cloneNode(true);
      Array.from(clone.children).forEach(function(child) {
        track.appendChild(child);
      });
      track.style.animation = 'stilMarquee 30s linear infinite';
      const parent = track.parentElement;
      if (parent) {
        parent.addEventListener('mouseenter', function() { track.style.animationPlayState = 'paused'; });
        parent.addEventListener('mouseleave', function() { track.style.animationPlayState = 'running'; });
      }
    });

    // --- Blur-up image loading ---
    document.querySelectorAll('.stilenza-blur-up').forEach(function(wrapper) {
      const img = wrapper.querySelector('img[data-src]');
      if (!img) return;
      const fullSrc = img.dataset.src;
      const fullImg = new Image();
      fullImg.onload = function() {
        img.src = fullSrc;
        wrapper.classList.add('is-loaded');
      };
      fullImg.src = fullSrc;
    });
  };

  // Use requestIdleCallback to avoid blocking main thread, fallback to rAF
  if ('requestIdleCallback' in window) {
    requestIdleCallback(init);
  } else {
    requestAnimationFrame(init);
  }

  window.addEventListener('pagehide', function() {
    _observers.forEach(function(o) { o.disconnect(); });
  });
})();
